__webpack_require__.p = "/cdysxy/mobile/sccp/";